import { Box, Stack } from "@mui/system";

import styles from "./styles";
import congaLogo from "assets/trustedByList/conga.webp";
import kobasLogo from "assets/trustedByList/kobas.webp";
import cloudLogo from "assets/trustedByList/cloud-23.webp";
import oferteoLogo from "assets/trustedByList/oferteo.webp";
import tessellLogo from "assets/trustedByList/tessell.webp";
import perpetioLogo from "assets/trustedByList/perpetio.webp";
import ricksoftLogo from "assets/trustedByList/ricksoft.webp";
import goavantoLogo from "assets/trustedByList/go-avanto.webp";
import blueberryLogo from "assets/trustedByList/blueberry.webp";
import clipboardLogo from "assets/trustedByList/clipboard.webp";
import sidebenchLogo from "assets/trustedByList/sidebench.webp";
import realtimeRoboticsLogo from "assets/trustedByList/realtime-robotics.webp";

const TrustedBySection = () => {
  const classes = styles();

  const logos = [
    { src: tessellLogo, alt: "Tessell" },
    { src: ricksoftLogo, alt: "Ricksoft" },
    { src: perpetioLogo, alt: "Perpetio" },
    { src: realtimeRoboticsLogo, alt: "Realtime Robotics" },
    { src: oferteoLogo, alt: "Oferteo" },
    { src: blueberryLogo, alt: "Blueberry" },
    { src: goavantoLogo, alt: "Goavanto" },
    { src: clipboardLogo, alt: "Clipboard" },
    { src: congaLogo, alt: "Conga" },
    { src: kobasLogo, alt: "Kobas" },
    { src: cloudLogo, alt: "Cloud 23" },
    { src: sidebenchLogo, alt: "Sidebench" }
  ];

  return (
    <Stack
      direction={"column"}
      alignItems={"center"}
      textAlign={"center"}
      gap={"24px"}
      sx={{ marginTop: { xs: "60px", md: "48px" } }}
    >
      <h2 className={classes.trusedByTitle}>
        Trusted by modern teams redefining workplace culture
      </h2>

      <Box className={classes.trustedByListContainer}>
        <Box
          className={classes.fadeLeft}
          sx={{ width: { xs: "40px", sm: "80px" } }}
        />

        <Box
          className={classes.fadeRight}
          sx={{ width: { xs: "40px", sm: "80px" } }}
        />

        <Box className={classes.trustedByAnimatedWrapper}>
          {logos.map((logo) => (
            <img key={logo.alt} src={logo.src} alt={logo.alt} loading="lazy" />
          ))}

          {logos.map((logo, index) => (
            <img
              key={`${logo.alt}-dup`}
              src={logo.src}
              alt={logo.alt}
              loading="lazy"
            />
          ))}
        </Box>
      </Box>
    </Stack>
  );
};

export default TrustedBySection;
